import React, { Fragment, Component } from 'react';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import SnackerBar from '../../utils/SnackerBar';
import { Global, inlineStyles } from '../../utils/global';
import { EnhancedTableToolbar, EnhancedTableHead } from '../../utils/common_page_with_table';
import { Box, Grid, Table, TableBody, TableRow, TableCell, IconButton, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, MenuItem } from '@material-ui/core';

import 'date-fns';
import '../../styles.css';

const url = 'gl/accountgroups.php';

export default class AccountGroups extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: 0,
            addNew: false,
            deleteDialogOpen: false,
            notification: '',
            isLoading: true,
            isDataLoading: false,
            selectedID: 0,
            objName: '',
            schema: [],
            order: 'asc',
            orderBy: 1,
            page: 0,
            pageTotal: 0,
            rows: [],
            rowsPerPage: 100,
            searchFor: '',
            selected: [],
            snackBarMsg: '',
            snackBarMsgType: '',
            snackBarOpen: false,
            url: props.parentComponent.state.API_HOST + url,
        };
    }
    openSnackBar = (snackBarMsg, snackBarMsgType, snackBarOpen) => {
        this.setState({ snackBarMsg: snackBarMsg, snackBarMsgType: snackBarMsgType, snackBarOpen: snackBarOpen });
    }
    handleTextfieldChange = (name) => event => {
        Global.setStateValue(this, name, event.target.value);
        return;
    };
    handleRequestSort = (event, property) => {
        var isDesc = this.state.order === 'desc';
        var order = isDesc || this.state.orderBy !== property ? 'asc' : 'desc';
        var values = {
            order: order,
            orderBy: property,
        };
        this.setComponentState('order', order);
        this.setComponentState('orderBy', property);
        Global.loadList(this, values);
    }
    setComponentState = (sState, vState) => {
        this.setState({ [sState]: vState });
    }
    addNew = (v) => {
        this.setState({ addNew: v });
    }
    editRow = (row) => {
        console.log('x',row);
        this.setState({ id: row[0] });
        Global.setStateValue(this, 'acode', row[4]+row[1]);
        Global.setStateValue(this, 'groupname', row[2]);
        Global.setStateValue(this, 'parent', row[5]);
        Global.setStateValue(this, 'pandl', row[3]);
        this.addNew(true);
    }
    confirmDeleteRow(row) {
        this.setState({ id: row.transCatID });
        this.setState({ objName: row.transCatName });
        this.setDeleteDialogOpen(true);
    }
    confirmDeletion = (id) => {
        Global.deleteRow(this, id);
    }
    setDeleteDialogOpen = (v) => {
        this.setState({ deleteDialogOpen: v });
        if (!v) {
            Global.loadList(this, { isDataLoading: false });
        }
    }
    actionButtons = () => {
        return (
            <Box style={inlineStyles.toolbarActionBox}>
                <Button onClick={() => { this.addNew(true) }} style={inlineStyles.buttonOrange} variant='contained' size="small">
                    <Icon className="fas fa-plus" style={inlineStyles.smallIcon}></Icon>Add Account Group
                </Button>
            </Box>
        )
    }
    handleSelectAllClick = (event) => {
        if (event.target.checked) {
            var newSelecteds = this.state.rows.map(n => n.name);
            this.setComponentState('selected', newSelecteds);
            return;
        }
        this.setComponentState('selected', []);
    }

    handleChangePage = (event, newPage) => {
        this.setComponentState('page', newPage);
        Global.loadList(this, { page: newPage });
    }

    handleChangeRowsPerPage = (event) => {
        this.setComponentState('rowsPerPage', event.target.value);
        Global.loadList(this, { rowsPerPage: event.target.value });
    }
    componentDidMount() {
        if (this.state.isLoading && !this.state.isDataLoading) {
            Global.getSchema(this, false); /* if second parameter is true, the record to edit will be loaded (getOneRow()); else list will be loaded */
        }
    }
    render() {
        const reportTitle = 'Chart of Accounts'
        var values = this.state.schema;
        var headRows = [];
        headRows.push({ id: 'groupcode', label: 'Group Code | Name', numeric: false, showInList: true });
        headRows.push({ id: 'action', label: 'Actions', numeric: false, showInList: true });
        return (
            <Fragment>
                <Paper style={inlineStyles.paper}>
                    {
                        this.state.notification &&
                        <Typography paragraph color="error" align="center" style={{ 'padding': 20 }}>
                            {this.state.notification}
                        </Typography>
                    }
                    {
                        this.state.isDataLoading &&
                        <Fragment>
                            <div style={{ 'padding': 50, 'textAlign': 'center' }}>
                                <CircularProgress />
                            </div>
                        </Fragment>
                    }

                    {!this.state.isDataLoading &&
                        <Fragment>
                            <EnhancedTableToolbar
                                numSelected={0}
                                toolbarTitle={reportTitle}
                                actionButtons={this.state.addNew ? '' : this.actionButtons}
                                t={this}
                                Global={Global}
                            />
                            {this.state.addNew &&
                                <Fragment>
                                    <form autoComplete="off" style={inlineStyles.editform}>
                                        <Grid container spacing={2}>
                                            {values.filter((row) => row.type !== 'hidden').map((row, index) => {
                                                var menuItems = row.type === 'select' ? row.items : '';
                                                return (
                                                    row.type === 'select' ?
                                                    <Grid item xs={12} md={row.gridSize ? row.gridSize : 4} key={index}>
                                                        <TextField
                                                            select
                                                            variant="outlined"
                                                            margin="dense"
                                                            autoFocus={row.name==='acode' ? true : false}
                                                            name={row.name}
                                                            label={row.error ? row.error : row.label}
                                                            value={row.value ? row.value : ''}
                                                            onChange={this.handleTextfieldChange(row.name)}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            disabled={this.state.isDataLoading}
                                                        >
                                                            <MenuItem value={0}>Choose {row.label}</MenuItem>
                                                            {
                                                                menuItems.length > 0 && menuItems.map((itemrow, itemindex) => {
                                                                    return (
                                                                        <MenuItem key={itemindex} value={itemrow.key}>{itemrow.value}</MenuItem>
                                                                    )
                                                                })
                                                            }

                                                        </TextField>
                                                    </Grid>
                                                    :
                                                    <Grid item xs={12} md={row.gridSize ? row.gridSize : 4} key={index}>
                                                        <TextField
                                                            error={row.error ? true : false}
                                                            autoFocus={row.name==='acode' ? true : false}
                                                            variant="outlined"
                                                            margin="dense"
                                                            name={row.name}
                                                            required={row.required}
                                                            label={row.error ? row.error : row.label}
                                                            value={row.value}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            onChange={this.handleTextfieldChange(row.name)}
                                                            disabled={this.state.isDataLoading}
                                                        />
                                                    </Grid>
                                                )
                                            })
                                            }
                                            <Grid item xs={2} style={{ paddingTop: 15 }}>
                                                <Button onClick={Global.handleSaveForm(this)} style={inlineStyles.button} color="primary" variant='contained' size="small">
                                                    <Icon className="fas fa-save" style={inlineStyles.smallIcon}></Icon>Save
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </form>
                                </Fragment>
                            }
                            <div style={inlineStyles.tableWrapper}>
                                <Table
                                    aria-labelledby="tableTitle"
                                    size='small'
                                >

                                    <EnhancedTableHead
                                        numSelected={this.state.selected ? this.state.selected.length : 0}
                                        order={this.state.order}
                                        orderBy={this.state.orderBy}
                                        onSelectAllClick={this.handleSelectAllClick}
                                        onRequestSort={this.handleRequestSort}
                                        headRows={headRows}
                                    />
                                    <TableBody>
                                        {this.state.rows.hasOwnProperty('categories') && this.state.rows.categories.length > 0 && this.state.rows.categories.map((value, index) => {
                                            const colindex = `table-row-${index}`;
                                            var rows = value.split("/");
                                            var padX = 20 * rows[3];
                                            var padLeft = {paddingLeft: padX};
                                            return (
                                                <TableRow
                                                    hover
                                                    key={index}
                                                >
                                                    <TableCell className="listRowNum" scope="row" padding="none" align="center">
                                                        {index + 1 + (this.state.page * this.state.rowsPerPage)}
                                                    </TableCell>
                                                    <TableCell key={colindex}>                                                        
                                                        {
                                                        rows[3]>0
                                                        ?
                                                        <Fragment>
                                                            <div style={padLeft}>
                                                            <sup>L</sup> {rows[4]}{rows[1]} -- {rows[2]}
                                                            </div>
                                                        </Fragment>
                                                        :
                                                        <Fragment>
                                                            <font class="mainheader"> {rows[4]}{rows[1]} -- {rows[2]} </font>
                                                        </Fragment>
                                                        }

                                                    </TableCell>

                                                    <TableCell align="center" style={{ whiteSpace: 'nowrap' }}>
                                                        <IconButton style={inlineStyles.iconButton} onClick={() => this.editRow(rows)} aria-label="Edit row">
                                                            <Icon className={'fas fa-edit fa-small '} color="primary" />
                                                        </IconButton>
                                                        <IconButton style={inlineStyles.iconButton} onClick={() => this.confirmDeleteRow(value)} aria-label="Delete row">
                                                            <Icon className={'fas fa-trash-alt fa-small'} color="error" />
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })
                                        }
                                        
                                    </TableBody>
                                </Table>
                            </div>

                        </Fragment>
                    }

                </Paper>
                <Dialog
                    open={this.state.deleteDialogOpen}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Confirm"}</DialogTitle>
                    <DialogContent dividers>
                        <DialogContentText id="alert-dialog-description"></DialogContentText>
                        <div style={{ padding: 15 }}>
                            Do you want to continue deleting "{this.state.objName}"?
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.setDeleteDialogOpen(false)} variant='contained' color="secondary" size="small" style={inlineStyles.button}>
                            No
                    </Button>
                        <Button onClick={() => this.confirmDeletion(this.state.id)} variant='contained' color="primary" size="small" style={inlineStyles.button} autoFocus>
                            Yes
                    </Button>
                    </DialogActions>
                </Dialog>
                <SnackerBar msg={this.state.snackBarMsg} msgType={this.state.snackBarMsgType} opened={this.state.snackBarOpen} t={this} />
            </Fragment>
        );
    }
}

